import React, { useState, useRef, useEffect, useMemo } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';

const Navigation: React.FC = () => {
  const [expanded, setExpanded] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const navbarToggleRef = useRef<HTMLButtonElement>(null);
  
  const handleNavLinkClick = (sectionId: string) => {
    // Close the navbar when a link is clicked in mobile view
    setExpanded(false);
    // Let the intersection observer handle the active section
  };
  
  const navItems = useMemo(() => [
    { href: "#hero", label: "Home", id: "hero" },
    { href: "#about", label: "About", id: "about" },
    { href: "#projects", label: "Projects", id: "projects" },
    { href: "#experience", label: "Experience", id: "experience" },
    { href: "#skills", label: "Skills", id: "skills" },
    { href: "#contact", label: "Contact", id: "contact" }
  ], []);

  // Set up intersection observer to detect which section is in view
  useEffect(() => {
    const sectionIds = navItems.map(item => item.id);
    
    const observerOptions = {
      root: null, // viewport
      rootMargin: '-5% 0px -85% 0px', // Section becomes active when near the top of viewport
      threshold: 0
    };

    const handleIntersect = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);
    
    // Observe all sections
    sectionIds.forEach(id => {
      const element = document.getElementById(id);
      if (element) observer.observe(element);
    });

    return () => {
      // Cleanup observer on component unmount
      sectionIds.forEach(id => {
        const element = document.getElementById(id);
        if (element) observer.unobserve(element);
      });
    };
  }, [navItems]);

  return (
    <Navbar bg="dark" variant="dark" expand="lg" fixed="top" className="py-3" expanded={expanded} onToggle={setExpanded}>
      <Container>
        <Navbar.Brand href="#hero" className="fw-bold">
          Nick Marcuzzo
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" ref={navbarToggleRef} />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {navItems.map((item, index) => (
              <Nav.Link 
                key={index} 
                href={item.href} 
                className="mx-2"
                active={activeSection === item.id}
                onClick={() => handleNavLinkClick(item.href)}
              >
                {item.label}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
